<template>
  <router-link
    class="link"
    :to="{ name: 'checkout', params: { lang: language } }"
    v-on:click="clicked()"
  >
    <Icon :icon="cartIcon" class="cartIcon" v-bind:class="{ notEmpty: count !== 0, cartIconCart: cartIcon === 'shoppingCart' }"></Icon>
    <span class="number">{{ count }}</span>
  </router-link>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '../Icon.vue';

export default {
  name: 'BasketComponent',
  emits: ['click'],
  components: {
    Icon,
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      count: (state) => state.cart.form.length,
    }),
    cartIcon() {
      return ['wvh', 'devwvh'].includes(import.meta.env.VITE_SITE_FRONT_ID)
        ? 'shoppingCart'
        : 'shoppingBag';
    },
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.cartIcon {
  display: inline-block;
  margin-right: $sp;
}
.cartIconCart :deep(svg) {
  padding-top: 4px;
  vertical-align: top;
}

.cartIcon,
.number {
  color: $navbar-default-link-color;
}
.cartIcon.notEmpty {
  text-shadow: white 0 0 10px;
}
.link:hover {
  text-decoration: none;
  span {
    text-decoration: underline;
  }
}
.link.router-link-active:hover {
  text-decoration: none;
  font-weight: 300;
  cursor: default;
}
</style>
